

export const AuthSignupForm = ({ onSubmit }) => {
  window.location.href = "https://join.kommuter.de";

  return null;
};
